function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.18335 7.50001C3.6187 5.35331 6.7536 4.16888 10 4.16888C13.2464 4.16888 16.3813 5.35331 18.8167 7.50001",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  className: "bar bar3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.16663 10.4583C5.81376 9.0864 7.88963 8.33511 10.0333 8.33511C12.177 8.33511 14.2528 9.0864 15.9 10.4583",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  className: "bar bar2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.10828 13.425C7.95428 12.8239 8.96634 12.501 10.0041 12.501C11.0419 12.501 12.0539 12.8239 12.8999 13.425",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  className: "bar bar1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2 15 l17,-12",
  stroke: "red",
  strokeWidth: 1.4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  className: "crossout"
});

var SvgErplyWifi = function SvgErplyWifi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgErplyWifi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/erply_wifi.4ba2e233.svg";
export { ForwardRef as ReactComponent };